import { useSystemConfiguration } from '@/hooks/theme/useSystemConfiguration';
import { OriginId } from '@starsoft/common/models/origin/id';
import AuthModalContentLoginStepsOriginRendererBrazil from './Brazil';
import AuthModalContentLoginStepsForm from '../Form';

export default function AuthModalContentLoginStepsOriginRenderer() {
  const { originId } = useSystemConfiguration();
  switch (originId?.toString()) {
    case OriginId.Brazil?.toString():
      return <AuthModalContentLoginStepsOriginRendererBrazil />;
    default:
      return <AuthModalContentLoginStepsForm />;
  }
}
